import { FormationAreaType } from "../../types/FormationAreaType";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { FORMATION_AREAS } from "../../utils/constants";


export const createFormationArea = async (data: FormationAreaType) => {
    return await post<FormationAreaType, string>(FORMATION_AREAS, data);
};

export const updateFormationArea = async (data: FormationAreaType) => {
    return await put<FormationAreaType, string>(FORMATION_AREAS, data);
};

export const getFormationAreas = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
    });
    const url = `${FORMATION_AREAS}?${queryParams.toString()}`;
    return await get<PagedResultsType<FormationAreaType>>(url);
};
